export interface IVerifyOtpBody {
  mfaSessionId: string;
  otp: string;
}

export interface IResendOtpBody {
  mfaSessionId: string;
}

export interface IOtpSession {
  mfaSessionId: string;
  maskedEmail: string;
  maskedPhone: string;
  otpExpirySeconds: number;
  otpDeliveryMethod: string;
}

export const OTP_SESSION_KEY = 'OTP_SESSION';
